import SerpGrid from './SerpGrid'

export default [
	{
		path: '/backend/serp-grid',
		name: 'backend.serp-grid',
		component: SerpGrid
	},
]
